import React, { useState, useEffect } from 'react';

const heroSlides = [
  // { bg: '/banners/B2b Grocery website.png', type: 'image' },
  { bg: '/banners/B2cSlider-1.png', type: 'image' },
   { bg: '/banners/B2cSlider-2.png', type: 'image' },
  { bg: '/banners/B2cSlider-3.png', type: 'image' },
  


];

export default function HeroSlider() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => goTo((prev => (prev + 1) % heroSlides.length)), 5000);
    return () => clearInterval(timer);
  }, []);

  const goTo = (idx) => {
    setAnimating(true);
    setTimeout(() => { setCurrent(typeof idx === 'function' ? idx(current) : idx); setAnimating(false); }, 350);
  };

  const slide = heroSlides[current];

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .hero-slider-container {
            margin: 0.5rem 0 !important;
          }
          .hero-slide {
            min-height: 250px !important;
          }
          .hero-slide img {
            max-height: 300px !important;
          }
          .hero-content {
            padding: 1.5rem !important;
            max-width: 100% !important;
          }
          .hero-title {
            font-size: clamp(1.2rem, 5vw, 1.8rem) !important;
          }
          .hero-desc {
            font-size: 0.9rem !important;
            margin-bottom: 1.5rem !important;
          }
          .hero-btn {
            padding: 10px 20px !important;
            font-size: 0.85rem !important;
          }
          .hero-nav-btn {
            width: 32px !important;
            height: 32px !important;
            left: 8px !important;
          }
          .hero-nav-btn.right {
            left: auto !important;
            right: 8px !important;
          }
          .hero-nav-btn svg {
            width: 14px !important;
            height: 14px !important;
          }
          .hero-dots {
            bottom: 0.5rem !important;
            gap: 6px !important;
          }
          .hero-dot {
            width: 6px !important;
            height: 6px !important;
          }
          .hero-dot.active {
            width: 20px !important;
          }
        }
        @media (max-width: 480px) {
          .hero-slide {
            min-height: 200px !important;
          }
          .hero-slide img {
            max-height: 250px !important;
          }
          .hero-content {
            padding: 1rem !important;
          }
          .hero-title {
            font-size: 1.3rem !important;
          }
          .hero-desc {
            font-size: 0.85rem !important;
          }
          .hero-btn {
            padding: 8px 16px !important;
            font-size: 0.8rem !important;
          }
        }
      `}</style>
      <section style={{ marginTop: '1.5rem' }}>
        <div className="container hero-slider-container">
          <div style={{ position: 'relative', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.12)', background: '#1a3a1a', minHeight: 350 }} className="hero-slide">
            <div style={{ opacity: animating ? 0 : 1, transition: 'opacity 0.35s ease', width: '100%' }}>
              {slide.type === 'image' ? (
                <img src={slide.bg} alt="Banner" style={{ width: '100%', height: 'auto', maxHeight: 450, objectFit: 'cover', display: 'block' }} />
              ) : (
                <div style={{ backgroundImage: `url(${slide.bg})`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: 350, display: 'flex', alignItems: 'center', position: 'relative' }}>
                  <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to right, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.3) 55%, transparent 100%)' }} />
                  <div style={{ position: 'relative', zIndex: 1, padding: '3rem', maxWidth: 520 }} className="hero-content">
                    <span style={{ display: 'inline-block', padding: '4px 14px', background: '#eab308', color: '#111', borderRadius: '20px', fontSize: '0.8rem', fontWeight: 700, marginBottom: '1rem' }}>{slide.badge}</span>
                    <h1 style={{ fontSize: 'clamp(1.6rem, 3vw, 2.8rem)', fontWeight: 800, color: 'white', lineHeight: 1.15, marginBottom: '1rem' }} className="hero-title">{slide.title}</h1>
                    <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: '2rem', fontSize: '1rem', lineHeight: 1.6 }} className="hero-desc">{slide.desc}</p>
                    <a href="#!" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 28px', background: '#16a34a', color: 'white', borderRadius: '10px', fontWeight: 700, fontSize: '0.95rem', textDecoration: 'none' }} className="hero-btn">Shop Now →</a>
                  </div>
                </div>
              )}
            </div>
            <button onClick={() => goTo((current - 1 + heroSlides.length) % heroSlides.length)}
              style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.92)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.2)', zIndex: 10 }} className="hero-nav-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" strokeWidth="2.5" stroke="#374151" fill="none"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 6l-6 6l6 6"/></svg>
            </button>
            <button onClick={() => goTo((current + 1) % heroSlides.length)}
              style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', width: 40, height: 40, borderRadius: '50%', background: 'rgba(255,255,255,0.92)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 2px 12px rgba(0,0,0,0.2)', zIndex: 10 }} className="hero-nav-btn right">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" strokeWidth="2.5" stroke="#374151" fill="none"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 6l6 6l-6 6"/></svg>
            </button>
            <div style={{ position: 'absolute', bottom: '1rem', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '8px', zIndex: 10 }} className="hero-dots">
              {heroSlides.map((_, i) => (
                <button key={i} onClick={() => goTo(i)} style={{ width: i === current ? 28 : 8, height: 8, borderRadius: 4, background: i === current ? '#16a34a' : 'rgba(255,255,255,0.7)', border: 'none', cursor: 'pointer', transition: 'all 0.35s', padding: 0 }} className={i === current ? 'hero-dot active' : 'hero-dot'} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
